import(/* webpackMode: "eager" */ "/vercel/path0/src/components/center/inquiry/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/center-layout.tsx")